function processYotpoWidgets() {
  const wrappers = document.querySelectorAll('.yotpo-widget-wrapper');
  
  wrappers.forEach(wrapper => {
    const reviewEl = wrapper.querySelector('.yotpo-sr-bottom-line-text');
    const customStar = wrapper.querySelector('.yotpo-star-single');
    
    // console.log('customStar', customStar);
    // If the review text & custom star SVG exist,
    // Hide the custom star if the review text says the product has 0 reviews. 
    if (reviewEl && customStar) {
      const reviewText = reviewEl.innerText ? reviewEl.innerText.trim() : '';
      if(reviewText.startsWith('0')){
        // customStar.style.display =  'none' 
        customStar.style.opacity =  '0' 
      }else{
        customStar.style.opacity =  '1' 
      }
    }
  });
}

// Watch for Yotpo widgets being added
const observer = new MutationObserver(() => {
  if (document.querySelector('.yotpo-widget-wrapper')) {
    processYotpoWidgets();
  }
});

observer.observe(document.body, { childList: true, subtree: true });

// Run on page load and after a delay
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(processYotpoWidgets, 1000);
});
setTimeout(processYotpoWidgets, 3000);
